import React from "react";
import "./Rectangle.scss";

export default function Rectangle(props) {
  return <div className={`rectangle ${props.classnaming}`} />;
}
